import React, { Component } from "react";
import PropTypes from "prop-types";
import t from "babel-plugin-yate/macro";

import Icon from "./Icons/index";

class Pagination extends Component {
  renderPaginationOption = () => {
    const { totalPages } = this.props;

    const options = [];

    for (let index = 1; index <= totalPages; index++) {
      options.push(
        <option value={index} key={index}>
          {index}
        </option>
      );
    }
    return options;
  };

  render() {
    const { totalPages, currentPage, gotoPage, items } = this.props;

    const nextDisabled = currentPage === totalPages;
    const prevDisabled = currentPage === 1;

    return (
      <>
        <div className="font-medium text-12 mr-8">
          {t`Showing ${items} results`}
        </div>

        {totalPages > 1 && (
          <div className="font-medium text-12">
            <div className="flex w-32 bg-white border border-solid border-grey-dark rounded m-auto shadow_ appearance-none">
              <button
                className={`px-2 pt-3 pb-2 rounded z-10 ${
                  prevDisabled ? "opacity-25 pointer-events-none" : ""
                }`}
                disabled={prevDisabled}
                onClick={() => gotoPage(currentPage - 1)}
              >
                <span
                  className={`${prevDisabled ? "text-grey-1" : "text-black"}`}
                >
                  {<Icon name="PaginationArrowLeft" />}
                </span>
              </button>

              <select
                className={`h-8 appearance-none my-auto w-16 pl-3 border-l border-r rounded-none border-solid border-grey-dark bg-white ${
                  nextDisabled && prevDisabled
                    ? "opacity-25 pointer-events-none"
                    : ""
                }`}
                style={{ lineHeight: "18px" }}
                value={currentPage}
                onChange={event => gotoPage(event.target.value)}
                disabled={nextDisabled && prevDisabled}
              >
                {this.renderPaginationOption()}
              </select>

              <div className="pointer-events-none relative -ml-8 inset-y-0 right-0 flex items-center px-2 text-black">
                <svg
                  className="fill-current inline h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </div>

              <button
                className={`px-2 pt-3 pb-2 rounded ${
                  nextDisabled ? "opacity-25 pointer-events-none" : ""
                }`}
                disabled={nextDisabled}
                onClick={() => gotoPage(currentPage + 1)}
              >
                <span
                  className={`${nextDisabled ? "text-grey-1" : "text-black"}`}
                >
                  <Icon name="PaginationArrowRight" />
                </span>
              </button>
            </div>
          </div>
        )}
      </>
    );
  }
}

Pagination.propTypes = {
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  gotoPage: PropTypes.func.isRequired
};

export default Pagination;

